import React from "react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegCalendarAlt } from "react-icons/fa";
import { IoClose } from "react-icons/io5"; // أيقونة الإغلاق

function MobileDatePicker({
  selectedDate,
  setSelectedDate,
  direction = "bottom-start",
  ...props
}) {
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  return (
    <div className="relative w-full max-w-[160px]">
      <DatePicker
        selected={selectedDate}
        onChange={handleDateChange}
        dateFormat="yyyy-MM-dd"
        popperPlacement={direction}
        customInput={
          <div className="flex items-center gap-2  py-2 border rounded-lg border-gray-400 text-gray-400 text-sm bg-white w-full justify-between">
            <div className="flex items-center gap-1 px-1">
              {selectedDate ? (
                <span>{selectedDate?.toLocaleDateString("en-CA")}</span>
              ) : (
                <span>تصفية بالتاريخ</span>
              )}
              <FaRegCalendarAlt className="text-gray-500 text-base" />
            </div>
            {selectedDate && (
              <button
                type="button"
                className="text-gray-400 hover:text-red-500 transition"
                onClick={() => setSelectedDate(null)}
              >
                <IoClose className="text-lg" />
              </button>
            )}
          </div>
        }
        {...props}
      />
    </div>
  );
}

MobileDatePicker.propTypes = {
  selectedDate: PropTypes.instanceOf(Date),
  setSelectedDate: PropTypes.func.isRequired,
  direction: PropTypes.string,
};

export default MobileDatePicker;
